
























































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { MedicalSpecification } from "@/components/medicalEdit/types";
import { SelectItem } from "@/types";
import NumberInput from "@/components/common/NumberInput.vue";

@Component({
  components: { NumberInput }
})
export default class OtherMedical4 extends Vue {
  @Prop() tab!: MedicalSpecification;
  @Prop() reduction_unit_items!: SelectItem[]; //減額単位アイテムリスト
  @Prop() reduction_type_items!: SelectItem[]; //減額種類アイテムリスト
}
